/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _srcSettings = require('../../../src/settings');

var _srcSettings2 = _interopRequireDefault(_srcSettings);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRouter = require('react-router');

var _reactRedux = require('react-redux');

var _components = require('components');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _pluralize = require('pluralize');

var _pluralize2 = _interopRequireDefault(_pluralize);

var ColdBrew = (function (_Component) {
	_inherits(ColdBrew, _Component);

	function ColdBrew() {
		_classCallCheck(this, _ColdBrew);

		_Component.apply(this, arguments);
	}

	ColdBrew.prototype.render = function render() {
		var _classNames;

		var styles = require('./ColdBrew.css');
		var baseClasses = _classnames2['default']((_classNames = {}, _classNames[styles.Base] = true, _classNames[this.props.className] = this.props.className, _classNames[styles['Base--horizontal']] = this.props.horizontal, _classNames));

		var isSmallViewport = this.props.isSmallViewport;

		// How many years since this archival post?
		var now = _moment2['default']();
		var then = _moment2['default'](this.props.date, _srcSettings2['default'].dates.defaultFormat);
		var coldBrewPostYear = _moment2['default'](this.props.date, _srcSettings2['default'].dates.defaultFormat).format('YYYY');
		var yearSince = now.format('YYYY') - coldBrewPostYear;
		var monthsSince = now.diff(then, 'months');
		var timePassed = monthsSince < 12 ? monthsSince + ' ' + _pluralize2['default']('month', monthsSince) + ' ago' : yearSince + ' ' + _pluralize2['default']('year', yearSince) + ' ago';

		var subhead = isSmallViewport ? 'From the archives' : 'A refresher from the archives';

		return _react2['default'].createElement(
			'section',
			{ className: baseClasses },
			_react2['default'].createElement(_components.HeaderTab, { icon: 'icedCoffee', title: 'Cold Brew', subhead: subhead }),
			_react2['default'].createElement(
				'article',
				{ className: styles.Article },
				this.props.imageSrc ? _react2['default'].createElement(
					'figure',
					{ className: styles.Figure },
					_react2['default'].createElement(
						_reactRouter.Link,
						{ className: styles.Title, to: this.props.uri },
						_react2['default'].createElement('img', { className: styles.Image, src: '' + _srcSettings2['default'].cdn + this.props.imageSrc })
					),
					_react2['default'].createElement(
						'figcaption',
						{ className: styles.FigCaption },
						timePassed
					)
				) : null,
				_react2['default'].createElement(
					'div',
					{ className: styles.ContentArea },
					_react2['default'].createElement(_components.MetaBar, {
						author: this.props.author,
						authorURI: this.props.authorURI,
						categories: this.props.categories,
						postDate: this.props.date,
						specialSeries: this.props.specialSeries
					}),
					_react2['default'].createElement(
						'header',
						{ className: styles.Header },
						_react2['default'].createElement(
							'h1',
							{ className: styles.Title },
							_react2['default'].createElement(
								_reactRouter.Link,
								{ className: styles['Title--underlined'], to: this.props.uri },
								this.props.title
							)
						)
					),
					_react2['default'].createElement('div', { className: styles.Content, dangerouslySetInnerHTML: { __html: this.props.content } })
				)
			)
		);
	};

	_createClass(ColdBrew, null, [{
		key: 'propTypes',
		value: {
			author: _react.PropTypes.string.isRequired,
			authorURI: _react.PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.bool]),
			categories: _react.PropTypes.array,
			className: _react.PropTypes.string,
			content: _react.PropTypes.string.isRequired,
			date: _react.PropTypes.string.isRequired,
			horizontal: _react.PropTypes.bool,
			imageSrc: _react.PropTypes.string,
			isSmallViewport: _react.PropTypes.bool,
			specialSeries: _react.PropTypes.string,
			title: _react.PropTypes.string.isRequired,
			uri: _react.PropTypes.string.isRequired
		},
		enumerable: true
	}, {
		key: 'defaultProps',
		value: {
			uri: '/',
			author: 'The Author',
			content: '',
			date: 'May 11, 1973',
			horizontal: true,
			title: 'The Title'
		},
		enumerable: true
	}]);

	var _ColdBrew = ColdBrew;
	ColdBrew = _reactRedux.connect(function (state) {
		return {
			isSmallViewport: state.responsive.isSmallViewport,
			isMediumViewport: state.responsive.isMediumViewport,
			isLargeViewport: state.responsive.isLargeViewport
		};
	})(ColdBrew) || ColdBrew;
	return ColdBrew;
})(_react.Component);

exports['default'] = ColdBrew;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ColdBrew/ColdBrew.js
 ** module id = 675
 ** module chunks = 0
 **/